<app-rc-popin-content [isSingleColumn]="true" [size]="PopinSize.Calendar">
  <!-- Popin Form -->
  @if (form) {
    <div class="rc-popin__form mypopin__content">
      <div class="rc-popin__center rc-popin__wrapper">
        <div class="mypopin__title" popin_title-content>
          <h3 class="rc-title-gamma">{{ title }}</h3>
          <p class="rc-paragraph mypopin__title-desc">{{ subtitle }}</p>
        </div>
        <form (ngSubmit)="onSubmitForm($event)" [formGroup]="form" autocomplete="off" class="mypopin__form">
          @let error = dateErrorMessage();

          <div class="datepicker-wrapper">
            <div class="datepicker" [class.error-state]="error">
              <input
                formControlName="visitDate"
                autocomplete="off"
                matInput
                [min]="data?.minDate"
                [max]="data?.maxDate"
                [matDatepicker]="picker"
                id="datepicker-input"
                class="error-input"
                placeholder="{{ 'form-attribute_select-date' | translateKey }}"
              />
              <app-icon
                [class.error]="error"
                [name]="IconName.calendar_small"
                class="datepicker-icon"
                (click)="picker.opened ? picker.close() : picker.open()"
              ></app-icon>
              <mat-datepicker #picker></mat-datepicker>
            </div>
            @if (error) {
              <span class="datepicker-error">{{ error }}</span>
            }
          </div>
        </form>
      </div>
      <!-- Popin Footer -->
      @if (data.id !== 'init-date') {
        <div class="rc-popin__center rc-popin__footer">
          <div class="mypopin__footer-actions">
            <rc-link
              data-qa="vs-patient-page-weight-management-update-date-button-cancel"
              variant="secondary"
              size="large"
              (click)="dismiss()"
            >
              {{ 'action_cancel' | translateKey | titlecase }}
            </rc-link>
            <span i18n="@@action_separator">or</span>
            <rc-button
              data-qa="vs-patient-page-weight-management-update-date-button-update"
              [disabled]="form.invalid"
              (click)="onSubmitForm($event)"
            >
              {{ 'action_update' | translateKey | titlecase }}
            </rc-button>
          </div>
          <div class="mypopin__footer-text" popin_footer-content>
            <p>{{ footerText }}</p>
          </div>
        </div>
      } @else {
        <rc-button
          data-qa="vs-patient-page-weight-management-update-date-button-plan"
          [disabled]="form.invalid"
          (click)="onSubmitForm($event)"
        >
          {{ 'wm_plan_next_visit_pop_in-button' | translateKey }}
        </rc-button>
        <div class="mypopin__footer-text" popin_footer-content>
          <p>{{ footerText }}</p>
        </div>
      }
    </div>
  }
</app-rc-popin-content>
